import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-telegram",
  "use": "icon-telegram-usage",
  "viewBox": "0 0 49 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49 48\" id=\"icon-telegram\"><path d=\"M19.765 29.726l-.728 10.052c1.042 0 1.493-.44 2.034-.967l4.882-4.581 10.116 7.274c1.856 1.015 3.163.48 3.664-1.676l6.64-30.55.002-.001c.588-2.693-.992-3.746-2.8-3.085L4.543 20.863c-2.664 1.015-2.624 2.473-.453 3.134l9.979 3.047 23.18-14.24c1.09-.709 2.082-.316 1.266.393l-18.75 16.53z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol